export default __webpack_public_path__ + "static/media/Atharva Joshi.6a072f9d.jpg";